import { createContext, useContext } from "react";
import type { StoreInfo } from "../types";

// App reads the store once per visit and provides it here; components must not
// read it again, because every read counts against the storefront rate limit.
export const StoreInfoContext = createContext<StoreInfo | undefined>(undefined);

export function useStoreInfo() {
  const context = useContext(StoreInfoContext);
  if (context === undefined) {
    throw new Error("useStoreInfo must be used within App");
  }
  return context;
}
